import { forwardRef, type Ref, type SVGProps } from "react";
const IconFireFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M28.5 17.894q0-4.414-2.617-8.476t-7.188-7.11q-.86-.586-1.777-.058Q16 2.777 16 3.832v2.031q0 1.328-.918 2.227-.917.898-2.246.898a2.9 2.9 0 0 1-1.27-.293 3.3 3.3 0 0 1-1.074-.84 1.33 1.33 0 0 0-.8-.488 1.13 1.13 0 0 0-.919.215 12.4 12.4 0 0 0-3.867 4.492 12.55 12.55 0 0 0-1.406 5.82q0 3.438 1.68 6.27a12.9 12.9 0 0 0 2.555 3.113c.393.348.99-.194.824-.691a7.4 7.4 0 0 1-.371-2.363 7.5 7.5 0 0 1 .585-2.95q.587-1.386 1.68-2.48l4.845-4.743a1 1 0 0 1 1.402.003l4.808 4.74a8 8 0 0 1 1.719 2.5q.585 1.367.585 2.93 0 1.249-.37 2.363c-.166.497.43 1.039.823.692a12.9 12.9 0 0 0 2.555-3.114q1.68-2.832 1.68-6.27m-11.801.526a1 1 0 0 0-1.398 0l-2.621 2.56a4.7 4.7 0 0 0-1.016 1.485 4.4 4.4 0 0 0-.351 1.758q0 1.914 1.367 3.261T16 28.832t3.32-1.348 1.367-3.262q0-.898-.351-1.738a4.7 4.7 0 0 0-1.016-1.504z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconFireFilledSVG);
ForwardRef.displayName = "IconFireFilled";
export { ForwardRef as IconFireFilled };
